import { render, staticRenderFns } from "./ListDrag.vue?vue&type=template&id=0184cc6b&scoped=true"
import script from "./ListDrag.vue?vue&type=script&lang=js"
export * from "./ListDrag.vue?vue&type=script&lang=js"
import style0 from "./ListDrag.vue?vue&type=style&index=0&id=0184cc6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0184cc6b",
  null
  
)

export default component.exports